import { useState } from 'react'
import { Button } from '@/components/ui/Button'
import { Modal } from '@/components/ui/Modal'

/**
 * Deleting a reference row silently changes what the engine allows, so the
 * row being removed is named back to the user before it goes.
 */
export function ConfirmDeleteDialog({
  entity,
  label,
  onCancel,
  onConfirm,
}: {
  entity: string
  label: string
  onCancel: () => void
  onConfirm: () => Promise<void>
}) {
  const [working, setWorking] = useState(false)

  return (
    <Modal title={`Delete ${entity.toLowerCase()}`} onClose={onCancel} width="420px">
      <p className="t-body-md mt-3 text-body">{label}</p>

      <div className="mt-8 flex gap-3">
        <Button
          variant="secondary"
          fullWidth
          loading={working}
          onClick={() => {
            setWorking(true)
            onConfirm().catch(() => setWorking(false))
          }}
          className="text-semantic-down"
        >
          Delete
        </Button>
        <Button variant="secondary" onClick={onCancel} fullWidth>
          Cancel
        </Button>
      </div>
    </Modal>
  )
}
